import { Component, OnInit } from '@angular/core';
import { DashboardService } from '../../service/dashboard.service';
import { session } from '../../../../environments/environment.session';
import { AreaMapService } from '../../service/area-map.service'
import { TranslationService } from '../../service/translation.service';
import { ExcelService } from '../../service/file-export.service';
import { PdfGeneratorService } from '../../service/pdf-generator.service';

import Swal from 'sweetalert2';
interface SummaryStats {
  today: any;
  closed: number;
  totalGrievances: number;
  pending: number;
  resolved: number;
  escalated: number;
  avgResolutionTime: string;
}

interface EscalatedComplaint {
  id: string;
  title: string;
  generated: string;
  department: string;
  officer: string;
  daysPending: number;
}

interface DepartmentPerformance {
  departmentName: string;
  total: number;
  resolved: number;
  resolutionRate: number;
  averageDays: string;
}

interface GrievanceDataItem {
  title: string;
  total: number;
  pending: number;
  escalated: number;
  bgColor: string;
  department?: string;
  zone?: string;
}
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  constructor(private dashS: DashboardService, private areaMapService: AreaMapService, public translation: TranslationService, private excel: ExcelService, private pdfService: PdfGeneratorService) { }




  erpUser: any
  async ngOnInit() {

    this.erpUser = JSON.parse(atob(session.erpUser));
    let obj = { b_acct_id: this.erpUser.b_acct_id ,user_id:this.erpUser.le_id};
    await this.getArea();

    try {
      let resp = await this.dashS.getallComplaints(JSON.stringify(obj));
      if (resp['error'] == false) {
        console.log(resp['data']);
        // Set API values into summary stats
        this.summary.totalGrievances = resp['data']['total_complaints'];
        this.summary.pending = resp['data']['pending_complaints'];
        this.summary.resolved = resp['data']['total_resolved'];
        this.summary.closed = resp['data']['total_closed'];
        this.summary.today = resp['data']['total_today'];

        this.summary.escalated =  resp['data']['total_escalated']
      } else {
        console.error("API Error", resp['data']);
      }
    } catch (e) {
      console.error("API Exception", e);
    }

    // keep rest dummy
    // this.fetchSummaryStats();
    // this.fetchDepartmentPerformance();
    // this.fetchEscalatedComplaints();

    // this.departmentsList = ['All', ...this.grievancesData.department.map(d => d.title)];
    // this.zonesList = this.grievancesData.zone;
    // this.wardsList = this.grievancesData.ward;

    this.filteredZones = [];
    this.filteredWards = [];
    await this.getDashoard()
  }
  wordArr: any = []
  zoneArr: any = []
  async getArea() {
    let resp = await this.areaMapService.getAreaMapData({ b_acct_id: this.erpUser.b_acct_id })
    if (resp['error'] == false) {
      let temp: any = [];
      let wordtemp: any = [];
      this.wordArr = [];
      this.zoneArr = [];
      resp['data'].map((x: any) => {
        if (!temp.includes(x['zone_cd'])) {
          this.zoneArr.push(x);
          temp.push(x['zone_cd'])
        }
        if (x['word'] && !wordtemp.includes(x['word'])) {
          this.wordArr.push(x['word']);
          wordtemp.push(x['word']);
        }
      })
      console.log(this.wordArr)

      console.log(this.zoneArr)
    }
  }




  allDepartments: any[] = [];
  currentFilteredComplaints: any[] = [];
  departments: any = []
  async getDashoard() {
    let obj = { b_acct_id: this.erpUser.b_acct_id ,user_id:this.erpUser.le_id}
    let resp = await this.dashS.getDashoard(JSON.stringify(obj))
    if (resp['error'] == false) {
      console.log(resp)
      this.departments = resp['perFormanceData'];
      this.allDepartments = resp['perFormanceData']; // Store all departments for dropdown
      
      this.escalatedComplaints = resp['escalationData']; // Store all escalated complaints
      this.currentFilteredComplaints = this.escalatedComplaints;
      this.pagedEscalatedComplaints = resp['escalationData'];
      
      // Initialize pagination
      this.escalatedComplaints = resp['escalationData'];
this.currentFilteredComplaints = [...this.escalatedComplaints]; // ✅ copy karo
this.totalRecords = this.currentFilteredComplaints.length;
this.totalPages = Math.ceil(this.totalRecords / this.pageSize) || 1;
this.updatePagedData();
this.updatePages();
      // this.totalRecords = this.escalatedComplaints.length;
      // this.totalPages = Math.ceil(this.totalRecords / this.pageSize) || 1;
      // this.updatePagedData();
      // this.updatePages();

      this.grievancesData = resp['deptWiseGriData'];
      const colors = ['#73EDA0', '#FDAE77', '#FFE183', '#FB9D9D'];
      const usedColors = new Map<string, string>();

      this.grievancesData.forEach((item: any) => {
        if (!usedColors.has(item.department_name)) {
          const randomColor = colors[Math.floor(Math.random() * colors.length)];
          usedColors.set(item.department_name, randomColor);
        }
        item.bgColor = usedColors.get(item.department_name);
      });
    } else {
      Swal.fire('Opps !!', resp['data'], 'error')
    }
  }

  getSelectedViewLabel(): string {
    if (this.selectedWard) return this.translation.t('mcDashboard', 'ward');
    if (this.selectedZone) return this.translation.t('mcDashboard', 'zone');
    return this.translation.t('mcDashboard', 'department');
  }













  summary: SummaryStats = {
    totalGrievances: 0,
    pending: 0,
    resolved: 0,
    escalated: 0,
    avgResolutionTime: '0 Days',
    closed: 0,
    today:0
  };

  // departments: DepartmentPerformance[] = [];
  escalatedComplaints: any[] = [];

  filteredGrievancesData: any[] = [];
  selectedDepartment: any = null;
  selectedZone: any = null;
  selectedWard: any = null;


  departmentsList: string[] = [];
  zonesList: GrievanceDataItem[] = [];
  wardsList: GrievanceDataItem[] = [];

  filteredZones: GrievanceDataItem[] = [];
  filteredWards: any[] = [];

  // Pagination config
  currentPage = 1;
  pageSize = 5;
  totalRecords = 0;
  totalPages = 0;
  pages: (number | string)[] = [];
  pagedEscalatedComplaints: any[] = [];
  page_list = [5, 10, 20, 50, 100];

  // grievancesData: {
  //   department: GrievanceDataItem[];
  //   zone: GrievanceDataItem[];
  //   ward: GrievanceDataItem[];
  // } = {
  //   department: [
  //     { title: 'Water Supply', total: 2000, pending: 300, escalated: 20, bgColor: '#FFE183' },
  //     { title: 'Waste Management', total: 1800, pending: 500, escalated: 35, bgColor: '#FDAE77' },
  //     { title: 'Roads & Infrastructure', total: 2200, pending: 350, escalated: 40, bgColor: '#06BBDF' },
  //     { title: 'Public Health', total: 1700, pending: 250, escalated: 10, bgColor: '#FB9D9D' },
  //     { title: 'Traffic & Transport', total: 1900, pending: 400, escalated: 30, bgColor: '#FDAE77' },
  //     { title: 'Building Permits', total: 1600, pending: 200, escalated: 15, bgColor: '#73EDA0' }
  //   ],
  //   zone: [
  //     { title: 'Zone 1', total: 800, pending: 120, escalated: 5, bgColor: '#FB9D9D', department: 'Water Supply' },
  //     { title: 'Zone 2', total: 1100, pending: 200, escalated: 15, bgColor: '#FDAE77', department: 'Waste Management' },
  //     { title: 'Zone 3', total: 950, pending: 180, escalated: 12, bgColor: '#FFE183', department: 'Roads & Infrastructure' },
  //     { title: 'Zone 4', total: 1000, pending: 130, escalated: 8, bgColor: '#73EDA0', department: 'Public Health' }
  //   ],
  //   ward: [
  //     { title: 'Ward 5', total: 450, pending: 70, escalated: 4, bgColor: '#FFE183', zone: 'Zone 1' },
  //     { title: 'Ward 6', total: 520, pending: 90, escalated: 6, bgColor: '#73EDA0', zone: 'Zone 2' },
  //     { title: 'Ward 7', total: 480, pending: 80, escalated: 5, bgColor: '#FB9D9D', zone: 'Zone 3' },
  //     { title: 'Ward 8', total: 510, pending: 75, escalated: 7, bgColor: '#FDAE77', zone: 'Zone 4' }
  //   ]
  // };
  async filterGrievanceData() {
    await this.getdeptWiseGri();
    this.applyFilters();
  }






  async getdeptWiseGri() {
    let obj = { b_acct_id: this.erpUser.b_acct_id, department: this.selectedDepartment, zone_cd: this.selectedZone,ward:this.selectedWard }
    let resp = await this.dashS.getdeptWiseGri(JSON.stringify(obj))
    if (resp['error'] == false) {
      console.log(resp)
      this.grievancesData = resp['deptWiseGriData'];
      const colors = ['#73EDA0', '#FDAE77', '#FFE183', '#FB9D9D'];
      const usedColors = new Map<string, string>();
      this.grievancesData.forEach((item: any) => {
        if (!usedColors.has(item.department_name)) {
          const randomColor = colors[Math.floor(Math.random() * colors.length)];
          usedColors.set(item.department_name, randomColor);
        }
        item.bgColor = usedColors.get(item.department_name);
      });
    } else {
      Swal.fire('Opps !!', resp['data'], 'error')
    }

  }



  grievancesData: any = []

  fetchSummaryStats(): void {
    // this.summary = {
    //   // totalGrievances: 28471,
    //   // pending: 123456,
    //   // resolved: 1523,
    //   // escalated: 123456,
    //   // closed:7867,
    //   // avgResolutionTime: '4.2 Days'
    // };
  }

  fetchDepartmentPerformance(): void {
    // this.departments = [
    //   { departmentName: 'Water Supply Department', total: 2000, resolved: 200, resolutionRate: 8, averageDays: '2 days' },
    //   { departmentName: 'Waste Management Department', total: 1500, resolved: 300, resolutionRate: 20, averageDays: '3 days' },
    //   { departmentName: 'Roads & Infrastructure', total: 1800, resolved: 1000, resolutionRate: 55.5, averageDays: '1.8 days' },
    //   { departmentName: 'Public Health', total: 2200, resolved: 1200, resolutionRate: 54.5, averageDays: '2.5 days' },
    //   { departmentName: 'Traffic & Transport Department', total: 1700, resolved: 850, resolutionRate: 50, averageDays: '2.2 days' },
    //   { departmentName: 'Building Permits', total: 1000, resolved: 900, resolutionRate: 90, averageDays: '4 days' }
    // ];
  }

  fetchEscalatedComplaints(): void {
    this.escalatedComplaints = [
      { id: 'GRV-001', title: 'Water leakage issue near Sector 21', generated: '2025-06-01', department: 'Water Supply', officer: 'Amit Sharma', daysPending: 24 },
      { id: 'GRV-002', title: 'Garbage not collected in Zone 3', generated: '2025-06-05', department: 'Waste Management', officer: 'Rita Verma', daysPending: 20 },
      { id: 'GRV-003', title: 'Broken road needs urgent fixing', generated: '2025-06-03', department: 'Roads & Infrastructure', officer: 'Suresh Mehta', daysPending: 22 },
      { id: 'GRV-004', title: 'Open manhole in public park', generated: '2025-06-02', department: 'Public Health', officer: 'Neha Joshi', daysPending: 23 },
      { id: 'GRV-005', title: 'Streetlight not working in Ward 7', generated: '2025-06-06', department: 'Electrical Department', officer: 'Karan Singh', daysPending: 19 },
      { id: 'GRV-006', title: 'Illegal construction observed', generated: '2025-06-04', department: 'Building Control', officer: 'Pooja Rathi', daysPending: 21 },
      { id: 'GRV-007', title: 'Unregulated traffic in Zone 5', generated: '2025-06-07', department: 'Traffic & Transport', officer: 'Mohit Thakur', daysPending: 18 },
      { id: 'GRV-008', title: 'Drainage clogging during rain', generated: '2025-06-08', department: 'Sanitation', officer: 'Sneha Kumar', daysPending: 17 }
    ];
    this.totalRecords = this.escalatedComplaints.length;
    this.totalPages = Math.ceil(this.totalRecords / this.pageSize);
    this.updatePagedData();
    this.updatePages();
  }

  updatePagedData() {
    const start = (this.currentPage - 1) * this.pageSize;
    const end = start + this.pageSize;
    this.pagedEscalatedComplaints = this.currentFilteredComplaints.slice(start, end);
  }

  updatePages() {
    const pages: (number | string)[] = [];
    if (this.totalPages <= 7) {
      for (let i = 1; i <= this.totalPages; i++) pages.push(i);
    } else {
      if (this.currentPage <= 4) {
        pages.push(1, 2, 3, 4, 5, '...', this.totalPages);
      } else if (this.currentPage >= this.totalPages - 3) {
        pages.push(1, '...', this.totalPages - 4, this.totalPages - 3, this.totalPages - 2, this.totalPages - 1, this.totalPages);
      } else {
        pages.push(1, '...', this.currentPage - 1, this.currentPage, this.currentPage + 1, '...', this.totalPages);
      }
    }
    this.pages = pages;
  }

  goToPage(page: number | string) {
    if (typeof page !== 'number' || page < 1 || page > this.totalPages) return;
    this.currentPage = page;
    this.updatePagedData();
    this.updatePages();
  }

  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.updatePagedData();
      this.updatePages();
    }
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.updatePagedData();
      this.updatePages();
    }
  }
changePageSize() {
  this.currentPage = 1;
  this.totalRecords = this.currentFilteredComplaints.length; // ✅
  this.totalPages = Math.ceil(this.totalRecords / this.pageSize) || 1;
  this.updatePagedData();
  this.updatePages();
}
  // changePageSize() {
  //   this.currentPage = 1;
  //   this.totalRecords = this.escalatedComplaints.length;
  //   this.totalPages = Math.ceil(this.totalRecords / this.pageSize);
  //   this.updatePagedData();
  //   this.updatePages();
  // }

  searchText: string = '';
  
  filteredEscalatedComplaints: any[] = [];
  
  applyFilters() {
    let filtered = this.escalatedComplaints;

    if (this.searchText) {
      const searchStr = this.searchText.toLowerCase();
      filtered = filtered.filter((item: any) => {
        return Object.values(item).some((val: any) => 
          val && val.toString().toLowerCase().includes(searchStr)
        );
      });
    }

    // Filter by Zone/Dept/Ward if selected and if properties exist on items
    // Note: API might not return zone/ward in escalationData, but if it does:
    if (this.selectedZone) {
      filtered = filtered.filter((item: any) => !item.zone || item.zone === this.selectedZone);
    }
    if (this.selectedDepartment) {
      // Find the selected department object
      const selectedDeptObj = this.allDepartments.find((d: any) => d.dep_cd === this.selectedDepartment);
      const selectedDeptName = selectedDeptObj ? selectedDeptObj.department_name : null;

      filtered = filtered.filter((item: any) => 
        (item.dep_cd && item.dep_cd === this.selectedDepartment) || 
        (item.department && item.department === this.selectedDepartment) ||
        (selectedDeptName && item.department_name && item.department_name === selectedDeptName) ||
        (selectedDeptName && item.department && item.department === selectedDeptName)
      );
    }
    if (this.selectedWard) {
      filtered = filtered.filter((item: any) => !item.ward || item.ward === this.selectedWard);
    }

    this.filteredEscalatedComplaints = filtered;
    this.totalRecords = filtered.length;
    this.totalPages = Math.ceil(this.totalRecords / this.pageSize) || 1;
    
    // Adjust current page if out of bounds
    if (this.currentPage > this.totalPages) this.currentPage = 1;
    
    this.currentFilteredComplaints = filtered;
    this.updatePagedData();
    this.updatePages();
    
    // Filter Departments (Performance)
    let filteredDepts = this.allDepartments;
    if (this.selectedDepartment) {
        filteredDepts = filteredDepts.filter((dept: any) => dept.dep_cd === this.selectedDepartment);
    }
    this.departments = filteredDepts;
  }

  onFilterChange(): void {
    this.applyFilters();
  }

  // onDepartmentChange(dept: string | null) {
  //   this.selectedDepartment = dept;
  //   this.selectedZone = null;
  //   this.selectedWard = null;

  //   if (!dept || dept === 'All') {
  //     this.filteredZones = this.zonesList;
  //     this.filteredWards = [];
  //   } else {
  //     this.filteredZones = this.zonesList.filter(z => z.department === dept);
  //     this.filteredWards = [];
  //   }
  // }

  // onZoneChange(zone: string | null) {
  //   this.selectedZone = zone;
  //   this.selectedWard = null;
  //   this.filteredWards = zone ? this.wardsList.filter(w => w.zone === zone) : [];
  // }

  // onWardChange(ward: string | null) {
  //   this.selectedWard = ward;
  // }

  getSelectedView(): 'department' | 'zone' | 'ward' {
    if (this.selectedWard) return 'ward';
    if (this.selectedZone) return 'zone';
    return 'department';
  }

  // getDisplayedData(): any[] {
  //   if (this.selectedWard) return this.grievancesData.ward.filter(w => w.title === this.selectedWard);
  //   if (this.selectedZone) return this.grievancesData.ward.filter(w => w.zone === this.selectedZone);
  //   if (this.selectedDepartment && this.selectedDepartment !== 'All') return this.grievancesData.zone.filter(z => z.department === this.selectedDepartment);
  //   return this.grievancesData.department;
  // }

  calculatePath(rate: number): string {
    const filledWidth = 230 * (rate / 100);
    return `M0.5 6.5C0.5 3.18629 3.18629 0.5 6.5 0.5H${filledWidth.toFixed(2)}V12.5H6.5C3.18629 12.5 0.5 9.81371 0.5 6.5Z`;
  }

  getLabelStyle(rate: number): { [key: string]: string } {
    const filledWidth = 230 * (rate / 100);
    const centerOfRemainingBar = (filledWidth + 230) / 2;
    return {
      position: 'absolute',
      top: '50%',
      left: `${centerOfRemainingBar}px`,
      transform: 'translate(-50%, -50%)',
      fontSize: '10px',
      fontWeight: '400',
      fontFamily: 'Inter',
      color: '#000',
      lineHeight: '100%'
    };
  }
}
